import _ from 'lodash';
import { ItemServiceFactory } from '../../services/ItemServiceFactory';
import ConvokeObjectManager from './ConvokeObjectManager';

class ConvokeSourceObjectManager extends ConvokeObjectManager {
    constructor( id, coreContext, coreState, operationName, isWarning) {
        super( id, coreContext, coreState, (new ItemServiceFactory()).ItemServiceEnum.SourceObject,(new ItemServiceFactory()).ItemServiceEnum.SourceQuery, operationName, isWarning);
    }
}

export default ConvokeSourceObjectManager;